const authorizedMenuUrlList = [
   '/dashboard',
   '/site-policies',
   '/dashboard/notifications',
   '/dashboard/regulations',
   '/dashboard/mutual-world',
   '/dashboard/mutual-world/cuestionario',
   '/dashboard/mutual-world/response-questionary',
   '/dashboard/mutual-world/videos'
]

class AuthorizedURLService {
   validateStoredMenu = async (dispatch, userSettings) => {
      if (userSettings) {
         await this.setAppUrls(userSettings?.menus)

         dispatch({
            type: 'SET_AUTHORIZED_MENU_URL_LIST',
            authorizedMenuUrlList
         })
      }
   }

   setAppUrls = async menusArray => {
      menusArray &&
         menusArray.forEach(menuItem => {
            if (menuItem.menus === null) {
               authorizedMenuUrlList.push(`/dashboard${menuItem.url}`)
            } else {
               this.setAppUrls(menuItem.menus)
            }
         })
   }
}

export default AuthorizedURLService
